import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import HeaderDescription from "../../../../components/commons/HeaderDescription";
import { formatDateWithDays } from "../../../../helpers/formatDateWithDays";
import DisplayNameInput from "./DisplayNameInput";

const PersonalInfo = ({ onboardingData, CheckDisplayName, token }) => {
  return (
    <div>
      {/* form */}
      <div className="width-ful">
        <Formik
          initialValues={{
            displayName: onboardingData
              ? onboardingData?.user?.displayName || ""
              : "",
            fullName: onboardingData
              ? onboardingData?.user?.fullName || ""
              : "",
            phoneNumber: onboardingData
              ? onboardingData?.user?.phoneNumber || ""
              : "",
            email: onboardingData ? onboardingData?.user?.email || "" : "",
            address: onboardingData ? onboardingData?.user?.address || "" : "",
            addressLineTwo: onboardingData
              ? onboardingData?.user?.addressLineTwo || ""
              : "",
            postalCode: onboardingData
              ? onboardingData?.user?.postalCode || ""
              : "",
            activeCity: onboardingData
              ? onboardingData?.user?.activeCity || ""
              : "",
            activeCountry: onboardingData
              ? onboardingData?.user?.activeCountry || ""
              : "",
            role: onboardingData ? onboardingData?.user?.role || "" : "",
            verified: onboardingData
              ? onboardingData?.user?.verified
                ? 1
                : 0 || ""
              : "",
            registrationDate: onboardingData
              ? onboardingData?.user?.createdAt
                ? formatDateWithDays(onboardingData?.user?.createdAt)
                : ""
              : "",
          }}
        >
          {({ values }) => (
            <Form>
              <div className="bg-white main-section-spacing-md border-radius-8">
                <HeaderDescription
                  heading="Personal Information"
                  description="Fill in your personal details below."
                />

                <div className="mt-20">
                  {/* Display Name + Full Name */}
                  <div className="flex align-item-center gap-32">
                    {/* <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Display Name</label>
                        <Field
                          type="text"
                          name="displayName"
                          placeholder="Display Name"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="displayName"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div> */}

                    <div className="flex-1">
                      <DisplayNameInput
                        CheckDisplayName={CheckDisplayName}
                        token={token}
                        onboardingData={onboardingData}
                      />
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Full Name</label>
                        <Field
                          type="text"
                          name="fullName"
                          placeholder="Full Name"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="fullName"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Phone Number + Email */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Phone Number</label>
                        <Field
                          type="text"
                          name="phoneNumber"
                          placeholder="Phone Number"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="phoneNumber"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Email</label>
                        <Field
                          type="text"
                          name="email"
                          placeholder="Email Address"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="email"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Address */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Address Line 1</label>
                        <Field
                          type="text"
                          name="address"
                          placeholder="Address Line 1"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="address"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Address Line 2</label>
                        <Field
                          type="text"
                          name="addressLineTwo"
                          placeholder="Address Line 2"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="addressLineTwo"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Postal + City */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Postal Code</label>
                        <Field
                          type="text"
                          name="postalCode"
                          placeholder="Postal Code"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="postalCode"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Active City</label>
                        <Field
                          type="text"
                          name="activeCity"
                          placeholder="Active City"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="activeCity"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Country + Role Dropdown */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Active Country</label>
                        <Field
                          type="text"
                          name="activeCountry"
                          placeholder="Active Country"
                          className="type-input-focus"
                        />
                        <ErrorMessage
                          name="activeCountry"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Role</label>
                        <Field
                          as="select"
                          name="role"
                          className="type-input-focus"
                        >
                          <option value="">Select Role</option>
                          <option value="Driver">Driver</option>
                          <option value="Dispatcher">Dispatcher</option>
                        </Field>
                        <ErrorMessage
                          name="role"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Verified + Created At */}
                  <div className="flex align-item-center gap-32 mt-20">
                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Verification Status</label>
                        <Field
                          as="select"
                          name="verified"
                          className="type-input-focus"
                        >
                          <option value="">Select Status</option>
                          <option value="1">Verified</option>
                          <option value="0">Not Verified</option>
                        </Field>
                        <ErrorMessage
                          name="verified"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>

                    <div className="flex-1">
                      <div className="input-field-md-lg">
                        <label>Registration Date</label>
                        <Field
                          type="text"
                          name="registrationDate"
                          className="type-input-focus"
                          value={values.registrationDate}
                          readOnly
                        />
                        <ErrorMessage
                          name="registrationDate"
                          component="p"
                          className="text-danger font-10"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default PersonalInfo;
